import 'react-loading-skeleton/dist/skeleton.css';
import { setColorTheme } from '@facephi/ui-react';
import { createGlobalStyle } from 'styled-components';
import { desktopStyles, mobileStyles } from './utils';

export const GlobalStyles = createGlobalStyle`

@font-face {
    font-family: 'Poppins';
    src: url('/Poppins-Regular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    src: url('/Poppins-SemiBold.ttf') format('truetype');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }


  html {
    font-size: 62.5%;
    min-height: 100%;
    scroll-behavior: smooth;
    height: 100%;

  }

  body {
    line-height: 1;
    height: 100%;
  }

  #root {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-x: auto;
  }

  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  button {
    background: none;
    border: 0;
    cursor: pointer;
    padding: 0;
    &:focus {
      outline: none;
    }
  }
  a {
    text-decoration: none;
  }
  body {
    font-family: 'Poppins', sans-serif;
    overflow-x: hidden;
    background-color: #ffffff;
  }

  input, button {
    font-family: 'Poppins', sans-serif;
  }
  input[type=password]::-ms-reveal,
  input[type=password]::-ms-clear
    {
        display: none;
    }

  strong {
    font-weight: 600;
  }

  * {
    &::-webkit-scrollbar-track {
      background-color: #fff;
      border-radius: 2px;
      box-shadow: none;
    }

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #b3bdcd;
      border-radius: 8px;
      box-shadow: none;
    }
  }

  facephi-selphid-widget, facephi-selphi-widget {
    font-size: 16px;
    min-height: 550px;
  }
  
  lottie-widget {
      ${desktopStyles} {
      max-height: 350px;
      max-width: 304px;
      }

      ${mobileStyles} {
      max-height: 300px;
      max-width: 300px;
      }
  }

  .tip-widget {
    height: auto;
    width: 100%;
    align-items: center;
    ${mobileStyles} {
        justify-content: space-between;
    }

    ${desktopStyles} {
      width: 60rem;
      }

    .lottie-content {
      row-gap: 3.2rem;
      > * {
        border-radius: 0;
        }
    }

    .lottie-desktop {
      svg {
        border-radius: 1.6rem;
        background: ${setColorTheme('white')};
        overflow: hidden;
      }
      ${mobileStyles} {
        display: none;
      }
    }

    .lottie-mobile {
      ${desktopStyles} {
        display: none;
      }
    }

    p {
      font-size: 1.8rem;
      line-height: 2.7rem;
      color: ${setColorTheme('grey700')};
      text-align: center;
    }

    button {
      color: ${setColorTheme('white')};
      background: ${setColorTheme('blue400')};
      height: 4.8rem;
      padding: 0 3.2rem;
      border-radius: 0.8rem;
      font-size: 1.6rem;
      line-height: 2.1rem;
      font-weight: 600;
      font-family: inherit;
      box-sizing: border-box;
      object-fit: contain;
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 0.8rem;
      transition: all 0.25s ease-in-out;
      white-space: nowrap;
      position: relative;
      width: 100%;
      margin: 0 !important;
      text-transform: uppercase;

      &:disabled {
        background-color: ${setColorTheme('grey200')};
        cursor: default;
        color: ${setColorTheme('grey300')};
      }

      &:not(:disabled):hover {
        background-color: ${setColorTheme('blue500')};
      }
    }
  }
`;
